/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function Hunted() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Hunted4Kids (2025)</h1>
          <p>
            Hunted4Kids is geïnspireerd op het bekende TV programma hunted. Of eigenlijk is het gewoon hetzelfde, met slechts wat aanpassingen om het speelbaar te maken voor
            normale stervelingen zonder lijntje naar de AIVD.
          </p>
          <p>In het spel Hunted4Kids zijn er twee teams;</p>
          <ul>
            <li>De voortvluchtigen - Teams van 2 personen (2 kinderen en een ouder)</li>
            <li>De hunters - Teams van 2 personen (2 kinderen en een ouder)</li>
          </ul>
          <h2>De Voortvluchtigen</h2>
          <p>
            De voortvluchtigen krijgen informatie via een Whatsapp verzendlijst. Op deze verzendlijst ontvangen zij berichten, maar kunnen geen berichten versturen. De
            voortvluchtigen kunnen niet met elkaar communiceren. Via de verzendlijst krijgen zij na elkaar 4 GPS locaties door. Ze moeten die 4 locaties bezoeken want op die
            locaties moeten zij een envelop vinden met hun naam er op. In die 4 enveloppen zitten aanwijzingen / puzzels die ze moeten combineren tot 1 nieuwe GPS coördinaat; de
            "extractielocatie". Op die coördinaat liggen "extractie items" klaar; zodra ze deze hebben weten te pakken voor een hunter hen getikt heeft, hebben zij het spel
            gewonnen. Vooraf hebben de voortvluchtigen dus bijzonder weinig informatie.
          </p>
          <h2>De Hunters</h2>
          <p>
            De hunter teams kunnen wel met elkaar communiceren. Voor hun wordt een "Hunters" appgroep aangemaakt waarin ze vrij met elkaar kunnen communiceren. Met de
            voortvluchtigen loopt ook een volwassene mee. Iedere 10 minuten post deze persoon de locatie van de voortvluchtigen in deze appgroep. De Hunters krijgen dus met
            regelmaat de locaties door van de voortvluchtigen. met die informatie moeten zij de voortvluchtigen zien te grijpen (lees: tikken). Als 1 van de 2 voortvluchtigen
            getikt wordt, dan is dit team uit het spel. Zij dragen daarbij alle informatie die ze hebben bemachtigd op de 4 locaties over aan de hunters. De hunters krijgen geen
            inzage in de telefoon waarop de 4 GPS locaties zijn binnengekomen (via de verzendlijst).
          </p>
          <h2>Locatie</h2>
          <p>
            Dit spel kan in feite op een willekeurige locatie gespeeld worden. De enige noodzakelijke voorbereiding is het bepalen van de extractielocatie. Op die locatie worden de
            "extractie items" klaar gelegd. Dit zijn bijvoorbeeld vlaggetjes of iets dergelijks met "Missie volbracht!" er op. Verder moeten er 4 sets voorbereid worden met
            puzzels/hints die samen verwijzen naar deze extractielocatie. Het "werkgebied" moet ongeveer een cirkel zijn met een straal van 500 meter. Dan is het van punt naar punt
            maximaal 10 minuten lopen.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Hunted;
